<template>
    <div :name="`name${data.qid}`"  class="test_question list">
        <div class="title" 
            :style="{
                fontSize: bandingstyle.appearance.fontStemSize+'px',
                color:bandingstyle.appearance.fontStemColor,
                fontWeight: bandingstyle.appearance.fontStemBold,
                fontStyle: bandingstyle.appearance.fontStemItalic,
                textDecoration: bandingstyle.appearance.fontStemUnderline
            }"
        >
            <span v-if="data.mustanswer" class="required"></span>
            <HtmlClickImgEnlarge :content="data.questionsName"/>
        </div>

        <div>
            <template v-if="data.questionsTypeId == '35'">
                <div 
                    class="multiple" 
                    v-for="item in data.optionList" :key="item.oid"
                    :style="{
                        fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                        color:bandingstyle.appearance.fontOptionColor,
                        fontWeight: bandingstyle.appearance.fontOptionBold,
                        fontStyle: bandingstyle.appearance.fontOptionItalic,
                        textDecoration: bandingstyle.appearance.fontOptionUnderline,
                    }"
                >
                    <p class="item-title">
                        <HtmlClickImgEnlarge :content="item.labelName"/>
                    </p>
                    <div class="input_box answer-box">
                        <el-input
                            @change="userAnswerChange"
                            :class="{'input__err': item.validate}"
                            class="item-input"
                            resize="none"
                            type="textarea"
                            :rows="item.inputHeight == $t('UserAnswer.Small') ? 1 : (item.inputHeight == $t('UserAnswer.Middle') ? 2 : 3)"
                            v-model="item.userAnswer"
                            >
                        </el-input>
                        <div v-show="item.validate" class="form-item__error">{{item.validateMsg}}</div>
                    </div>
                </div>
            </template>
            <template v-else-if="data.questionsTypeId == '34'">
                <div
                    class="stem input_box"
                    :style="{
                        fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                        color:bandingstyle.appearance.fontOptionColor,
                        fontWeight: bandingstyle.appearance.fontOptionBold,
                        fontStyle: bandingstyle.appearance.fontOptionItalic,
                        textDecoration: bandingstyle.appearance.fontOptionUnderline,
                    }"
                    
                >   
                    <template v-for="(info, index) in questionOption">
                        <span v-if="typeof info == 'string'" v-html="info" :key="index"></span>
                        <input 
                            v-else class="input_box-border" :key="index"
                            @change="userAnswerChange"
                            :class="{'input__horizontal__err': data.optionList[info.index].validate}"
                            v-model="data.optionList[info.index].userAnswer" 
                            type="text" 
                            :style="`display: inline-block;width:${info.width}px;border: none;border-bottom: 1px solid;outline: none;text-align: center;`">
                    </template>
                    <template v-for="val in data.optionList">
                        <div :key="val.oid" 
                            v-show="val.validate" 
                            class="form-item__error">{{val.validateMsg}}
                        </div>
                    </template>
                </div>
            </template>
            <el-row  v-else-if="data.questionsTypeId == '37'">
                <el-col class="input_box" :span="24">
                    <p class="proportion-sum" v-if="data.isLimitSum">{{$t('UserAnswer.TotalSpecificGravity')}}: <span>{{actionSum}}/{{data.sum}}</span></p>
                    <div 
                        class="multiple" 
                        v-for="(item) in data.optionList" :key="item.oid"
                        :style="{
                            fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                            color:bandingstyle.appearance.fontOptionColor,
                            fontWeight: bandingstyle.appearance.fontOptionBold,
                            fontStyle: bandingstyle.appearance.fontOptionItalic,
                            textDecoration: bandingstyle.appearance.fontOptionUnderline,
                        }"
                    >
                        <p class="item-title">
                            <HtmlClickImgEnlarge :content="item.labelName"/>
                        </p>
                        <el-row>
                            <el-col :span="24">
                                <div class="el-slider-box">
                                    <span class="tip">{{data.minNum}}</span>
                                    <el-slider 
                                        v-model="item.userAnswer" 
                                        :max="data.maxNum" 
                                        :min="data.minNum" 
                                        :show-tooltip="false"
                                        @change="sumInput($event, item)"
                                    ></el-slider>
                                    <span class="tip">{{data.maxNum}}</span>
                                    <el-input 
                                        class="slider-input" 
                                        size="mini" 
                                        v-model.number="item.userAnswer"
                                        @oninput="value=value.replace(/[^0-9.]/g,'')"
                                    ></el-input>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-show="data.validate" class="form-item__error">{{data.validateMsg}}</div>
                </el-col>
            </el-row>
            <div v-else class="input_box answer-box"> 
                <el-input
                    v-if="data.inputHeight"
                    :class="{'input__err': data.validate}"
                    @blur="userAnswerChange"
                    :resize="data.questionsTypeId == '4' ? 'both' : 'none'"
                    type="textarea"
                    :rows="data.inputHeight == $t('UserAnswer.Big') ? 3 : (data.inputHeight == $t('UserAnswer.Middle') ? 2 : 1)"
                    v-model="data.userAnswer">
                </el-input>
                
                <el-input
                    v-else-if="data.cutType"
                    :class="{'input__err': data.validate}"
                    @blur="userAnswerChange"
                    :resize="data.questionsTypeId == '4' ? 'both' : 'none'"
                    type="textarea"
                    :rows="data.cutType == 2 ? 3 : 1"
                    v-model="data.userAnswer">
                </el-input>
                <div v-show="data.validate" class="form-item__error">{{data.validateMsg}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
export default {
    components: {
        HtmlClickImgEnlarge
    },
    props: {
        data: {},
        bandingstyle:{},
    },
    data() {
        return {
            checkList: [],
            questionOption: [],
            actionSum: 0,
        }
    },
    watch:{
        'data':{
            handler(newV) {
                if (newV.questionsTypeId == '34' || newV.questionsTypeId == '35') {
                    let result = false
                    if (newV.optionList.length > 0) {
                        newV.optionList.forEach((info) => {
                            if (info.userAnswer) {
                                result = true
                            }
                            // console.log(info.userAnswer)
                        })
                    }
                    if (result) {
                        newV.userAnswer = 1
                    } else {
                        newV.userAnswer = 0
                    }
                } else if (newV.questionsTypeId == '37'){
                    this.actionSum = 0
                    this.data.optionList.forEach((info)=> {
                        this.actionSum = info.userAnswer + this.actionSum
                    })
                }
            },
            deep: true,
            immediate: true
        },
        'data.questionsTypeId': {
            handler(newV) {
                if (newV == '34'){
                    this.questionOption = []
                    let str = this.data.quesOptionTitle
                    let arr = str.match(/_[_]+_/g)
                    
                    for(let i in arr){
                        let obj = JSON.stringify({width:arr[i].length * 10,})
                        str = str.replace(arr[i],`^${obj}^`)
                    }
                    let arrData = str.split('^')
                    for(let i in arrData){
                        if(arrData[i]){
                            this.questionOption.push(this.$functions.isJSON(arrData[i]) ? JSON.parse(arrData[i]) : arrData[i])
                        }
                    }
                    let index = 0
                    this.questionOption = this.questionOption.map((info) =>{
                        if((typeof info) != 'string'){
                            info.index = index
                            index++
                        } else {
                            info = this.$functions.HTMLClosedOrNot(info)
                        }
                        return info
                    })
                }
            },
            immediate: true
        }
    },
    created() {
    },
    methods: {
        userAnswerChange(){
            this.$emit('userAnswerChange', this.data)
        },
        sumInput(e, item) {
            if (this.data.isLimitSum) {
                let {optionList} = this.data
                this.data.optionList = this.data.optionList.map(val=> {
                    // 实时计算当前总数 不包含当前所滑动的模块
                    let num = optionList.filter(res=> res.oid != item.oid).map(res=> res.userAnswer).reduce((pre,curr)=> pre+curr)
                    // 判断两个时候
                    if(optionList.length == 2){
                        val.oid == item.oid ? val.userAnswer = e : val.userAnswer =  this.data.sum - e
                    }else{
                        if(val.oid == item.oid){
                            val.userAnswer = this.data.sum - num  < e ? this.data.sum - num  : e
                        }
                    }
                    return val
                })
                // 计算总数
                this.actionSum = optionList.map(res=> res.userAnswer).reduce((pre,curr)=> pre+curr)
            }
            // this.data = JSON.parse(JSON.stringify(this.data))
            this.userAnswerChange()
        }
    }
}
</script>

<style lang="scss" scoped>
.test_question{
    .option-box{
        display: flex;
        flex-direction: column;
        padding-left: 25px;
        .option+.option{
            margin-top: 10px;
        }
    }
}
.list{
    margin-top: 50px;
    .multiple{
        padding-left: 10px;
        .item-title{
            font-size: 14px;
            margin-bottom: 15px;
        }
    }
    .multiple+.multiple{
        margin-top: 20px;
    }
    .stem{
        padding-left: 10px;
        font-size: 14px;
        line-height: 30px;
    }
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
.input_box {
	position: relative;

	.form-item__error {
		color: #f56c6c;
		font-size: 12px;
		line-height: 1;
		padding-top: 4px;
	}
}

.input__horizontal__err{
    // font-size: 12px;
    // line-height: 1;
    // padding-top: 4px;
    border-bottom: 1px solid #f56c6c !important;
}
/deep/.input__err>.el-textarea__inner{
    border-color: #f56c6c;
}
.answer-box{
    width: 100%;
}
.input_box, 
.input_box-border{
    display: inline-block;
}
.proportion-sum{
    color: #999;
    font-size: 14px;
    margin-bottom: 16px;
}
.el-slider-box{
    display: flex;
    align-items: center;
    .el-slider{
        width: 100%;
        margin: 0 10px 0 18px;
        /deep/.el-slider__input{
            width: 60px;
        }
    }
    .tip{
        color: #999;
        font-size: 12px;
        
    }
    .slider-input {
        width: 100px;
        margin-left: 10px;
    }
}
</style>